<template>
    <div class="tachograph-day-detail-cell" :class="{ 'tachograph-day-detail-cell--warning': hasCarryOverWarning }">
        <button
            class="btn btn-light btn-xs btn-icon tachograph-day-detail-cell__button"
            :class="{ 'tachograph-day-detail-cell__button--warning': hasCarryOverWarning }"
            :disabled="!hasDetailId"
            v-b-tooltip.html.noninteractive.hover.left
            :title="detailPreview"
            v-on:click="openDetail"
        >
            <feather-icon icon="InfoIcon"></feather-icon>
        </button>
        <span
            v-if="hasCarryOverWarning"
            v-b-tooltip.noninteractive.hover.left
            :title="carryOverInfo"
            class="tachograph-day-detail-warning"
        >
            <feather-icon icon="AlertTriangleIcon" size="12"></feather-icon>
        </span>
    </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'

export default {
    directives: {
        'b-tooltip': VBTooltip,
    },
    props:{
        row:Object,
        field:[Object,String]
    },
    computed:{
        hasDetailId(){
            return !!(this.field && this.field.Id)
        },
        hasCarryOverWarning(){
            return !!(this.field && this.field.IsPartialCarryOverDay)
        },
        carryOverInfo(){
            return this.field && this.field.CarryOverInfo ? this.field.CarryOverInfo : ''
        },
        detailPreview(){
            if(!this.field){
                return ''
            }

            const items = [
                `<div><strong>Sürüş:</strong> ${this.formatValue(this.field.DrivingTime)}</div>`,
                `<div><strong>Rölanti:</strong> ${this.formatValue(this.field.WorkingTime)}</div>`,
                `<div><strong>Gece Çalışma:</strong> ${this.formatValue(this.field.NightWorkingTime)}</div>`,
                `<div><strong>Dinlenme:</strong> ${this.formatValue(this.field.RestTime)}</div>`,
            ]

            if(this.hasCarryOverWarning){
                items.push(`<div><strong>Taşma:</strong> Var</div>`)
            }

            return items.join('')
        }
    },
    methods:{
        formatValue(value){
            return value != null && value !== '' ? value : '-'
        },
        openDetail(){
            if(!this.hasDetailId){
                return
            }

            this.$emit('action',{
                row:this.row,
                ...this.field,
                id:this.field.Id,
            })
        }
    }
}
</script>

<style scoped>
.tachograph-day-detail-cell{
    display:flex;
    align-items:center;
    justify-content:center;
    gap:0.35rem;
    min-height:2rem;
    padding:0.1rem 0.2rem;
    border-radius:.7rem;
}

.tachograph-day-detail-cell--warning{
    background:linear-gradient(135deg,rgba(255,247,237,.95),rgba(255,251,235,.92));
    box-shadow:inset 0 0 0 1px rgba(245,158,11,.2);
}

.tachograph-day-detail-cell__button--warning{
    border-color:rgba(245,158,11,.34);
    background:rgba(255,247,237,.98);
    color:#b45309;
}

.tachograph-day-detail-warning{
    display:inline-flex;
    align-items:center;
    justify-content:center;
    width:1.2rem;
    height:1.2rem;
    border-radius:999px;
    background:rgba(245,158,11,.18);
    color:#b45309;
}
</style>
